import { type FeatureModule } from '@store/features/types';

import auditUiReducer from './auditUiSlice';

export const jotauditFeature: FeatureModule = {
  id: 'jotaudit',
  name: 'JotAudit',
  dependencies: [],
  reducers: {
    'jotaudit/ui': auditUiReducer,
  },
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};

